import PostMessageProcessor from '../processor';
import store from '/auto-message/src/redux/store';
import actionSetAutoMessage from '/auto-message/src/redux/actions/autoMessage/actionSetAutoMessageText';
import actionSetOpenState from '/auto-message/src/redux/actions/openState';

import Cookie from '/auto-message/src/lib/Cookie';

import selector from '/auto-message/src/redux/selector'

import SystemModel from '/auto-message/src/redux/model/system/model'

PostMessageProcessor.register('initializeData', function(payload) {



    const automessages = payload.features_payload.automessages;
    const prio = selector.getPriotizedAutoMessage(automessages)

    var frequency = 'always'
    if(!prio || !prio.message ) return;

    if(prio && prio.message && prio.message.frequency){
        frequency = prio.message.frequency
    }
    var showAutomessage = true;
    switch(frequency){
        case 'never':
            showAutomessage = false; break;
        case 'once24h':
            let cookie = `jibber-am-frequency-${prio.id}`
            if(Cookie.exists(cookie)){
                showAutomessage = false
            }else{
                Cookie.create(cookie, 1, 1)
                showAutomessage = true;
            }
            break;
        case 'always':
        default:
            showAutomessage = true;
            break;
    }

    // if offline then no automessage
    if(payload && payload.features_payload && payload.features_payload.offline && payload.features_payload.offline.status){
        showAutomessage = false
    }
    if (!showAutomessage) return;

    store.dispatch(actionSetAutoMessage(prio.message));
    store.dispatch(actionSetOpenState(showAutomessage));
    store.dispatch(SystemModel.set(payload));

});

PostMessageProcessor.register('openState', function(isOpen) {
    store.dispatch(actionSetOpenState(isOpen));
});



// WEBPACK FOOTER //
// ./postmessage/on/index.js